// extracted by mini-css-extract-plugin
export default {"shell":"layout-module_shell__duwvL","header":"layout-module_header__TRdtS","main":"layout-module_main__POuYV"};